import { Action, createReducer, on } from '@ngrx/store';
import { StatesState } from '../state/states.state';
import { loadStatesSuccess } from 'src/app/shared/actions/states.actions';

const initialState: StatesState = {
    states: undefined
};

const reducer = createReducer(
    initialState,

    on(loadStatesSuccess, (state, action) => ({
        ...state,
        states: action.states
    }))
);

export function statesReducer(state: StatesState | undefined, action: Action) {
    return reducer(state, action);
}
